import { WithStyles } from '@material-ui/core';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@material-ui/core/Stepper';

import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import SearchScenarioFactory from '../scenario/SearchScenarioFactory';
import { CMItemCode, isValid } from '../utils/CMData';
import { isMobile } from '../utils/MobileCheck';
const styles = (theme: Theme) =>
	createStyles({
		appBar: {
			position: 'relative',
		},
		flex: {
			flex: 1,
		},
		main: {
			paddingLeft: '180px',
			paddingRight: '180px',
		},
		mobileRoot: {
			position: 'relative',
			width: '100%',
		},
		mobileStepLabel: {
			textAlign: 'left',
		},
		root: {
			position: 'relative',
		},
		stepLabel: {
			textAlign: 'center',
		},
		wrapDiv: {
			margin: '10px',
		},
	});

/**
 * 目標設定部品公開プロパティー定義
 */
interface ISearchStepProp {
	cmFlag?: string;
	activeStep: number;
	backFlg?: boolean;
	onSetActiveStep?: (val: number) => void;
}

interface ISearchStepState {
	cmFlg: string;
}

interface IState {
	activeStep: number;
	stepDatas: IStepText[];
}

interface IStepText {
	br?: string;
	btnFlg?: boolean;
	text: string;
}

class SearchSteper extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);
		this.state = {
			activeStep: 0,
			stepDatas: [],
		};
	}
	public async componentDidMount() {
		const cmFlag = isValid(CMItemCode.CM_ENABLED);
		await this.props.fetchCMOptionValue(this.props.token, {});
		let stepDatas: IStepText[] = [];

		if (isMobile() || !cmFlag) {
			// CM(キャリアマネジメント)が無効の場合
			stepDatas = [
				{
					br: i18n.t('SearchSteper_0002'),
					text: i18n.t('SearchSteper_0001'),
				},
				{
					br: i18n.t('SearchSteper_0002'),
					btnFlg: this.props.backFlg,
					text: i18n.t('SearchSteper_0003'),
				},
				{ text: i18n.t('SearchSteper_0004') },
			];
		} else {
			// CM(キャリアマネジメント)が有効の場合
			stepDatas = [
				{
					br: i18n.t('SearchSteper_0002'),
					text: i18n.t('SearchSteper_0005'),
				},
				{
					br: i18n.t('SearchSteper_0002'),
					btnFlg: this.props.backFlg,
					text: i18n.t('SearchSteper_0006'),
				},
				{ text: i18n.t('SearchSteper_0004') },
			];
		}

		this.setState({
			activeStep: this.props.activeStep,
			stepDatas,
		});
	}

	/**
	 * プロパティー変更
	 * @param newProps
	 */
	public componentWillReceiveProps(newProps: any) {
		this.setState({ activeStep: newProps.activeStep });
	}

	public render() {
		const { classes } = this.props;
		return (
			<div className={!isMobile() ? classes.root : classes.mobileRoot}>
				<Stepper
					activeStep={this.state.activeStep}
					orientation={isMobile() ? 'vertical' : 'horizontal'}
				>
					{this.state.stepDatas.map((text, index) => {
						const stepProps: { completed?: boolean } = {};
						if (index > this.state.activeStep) {
							stepProps.completed = false;
						}
						return (
							<Step key={index} {...stepProps}>
								{this.renderStepBar(text, classes)}
							</Step>
						);
					})}
				</Stepper>
			</div>
		);
	}

	public renderStepBar(txt: IStepText, classes: any) {
		if (txt.btnFlg === true) {
			return (
				<StepButton onClick={this.setActiveStep}>
					{this.renderText(txt, classes)}
				</StepButton>
			);
		} else {
			return <StepLabel>{this.renderText(txt, classes)}</StepLabel>;
		}
	}

	public renderText(txt: IStepText, classes: any) {
		if (txt.br === undefined) {
			return (
				<div
					className={
						isMobile() ? classes.mobileStepLabel : classes.stepLabel
					}
				>
					{txt.text}
				</div>
			);
		} else if (!isMobile()) {
			return (
				<div className={classes.stepLabel}>
					{txt.text}
					<br />
					{txt.br}
				</div>
			);
		} else {
			return (
				<div className={classes.mobileStepLabel}>
					{txt.text}
					{txt.br}
				</div>
			);
		}
	}

	public setActiveStep = () => {
		if (this.props.onSetActiveStep) {
			this.props.onSetActiveStep(this.state.activeStep);
		}
	};
}

const mapStateToProps = (state: IRootState) => ({
	cmFlg: state.search.cmFlg,
	token: state.session.token,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	/**
	 * CM(キャリアマネジメント)を取得する。
	 */
	fetchCMOptionValue: (token: string, arg: any) => {
		const s = SearchScenarioFactory.getCMOptionValue(dispatch, token);
		return s.run(arg);
	},
});

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & ISearchStepProp & ISearchStepState;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(SearchSteper);

const Styled = withStyles(styles)(Connected);
const Export: React.ComponentType<ISearchStepProp> = Styled;

export default Export;



// WEBPACK FOOTER //
// ./src/components/SearchSteper.tsx